import {useState,useRef,useCallback} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {capitalize,prettyRound,envAwarePost,dataURLtoFile} from '../../../util/util'
import useCurrentUser from '../../../hooks/useCurrentUser'
import React from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import FormControl from 'react-bootstrap/FormControl'
import Form from 'react-bootstrap/Form'
import {
	updateNutritionMealPhoto,
	removeNutritionMealPhoto,
	logNutritionMealPhoto,
	removeNutritionItems,
	updateFoodDetails
} from '../../../state/events'
import {
	update as updateResourceLibrary
} from '../../ResourceLibrary/slice'
import {useDebounceCallback} from '@react-hook/debounce'

import {
	mealToMacroMap,
	foodToMacroMap,
	nutritionItemstoMacroMap
} from '../../../util/nutrition'

import BarcodeScanner from '../../BarcodeScanner/BarcodeScanner'
import FoodPortionSelect from '../../FoodPortionSelect/FoodPortionSelect'

import Modal from 'react-bootstrap/Modal'

import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'

import {addItemToEvent} from '../../../state/events'

import {useEvent} from '../../../hooks/events'

import useS3DirectUpload from '../../../hooks/useS3DirectUpload'

import Webcam from "react-webcam"

import heic2any from "heic2any";

const Food = ({food})=>{
	const dispatch = useDispatch()
	const [localQty,setLocalQty] = useState(food.quantity)

	const dispatchUpdate = quantity => {
		dispatch(updateFoodDetails({
			nutrition_id:food.nutrition_id,
			food_id:food.food_id,
			quantity
		}))
	}

	const debouncedDispatchEdit = useDebounceCallback(dispatchUpdate,500)

	const handleEditQuantity = e => {
		setLocalQty(e.target.value)
		debouncedDispatchEdit(e.target.value)
	}

	const handleRemove = ()=>{
		if(!window.confirm('Are you sure you want to delete this food?')) return
		dispatch(
			removeNutritionItems({
				nutrition_id:food.nutrition_id,
				items:[{type:'food',id:food.food_id}]
			})
		)
	}

	const portion = food.portions.find(
		p => parseInt(p.id) === parseInt(food.food_db_portion_id)
	) || food.portions[0]
	const macros = ['calories','carbs','protein','fat','fiber','sodium']
	return (
		<div style={{marginBottom:'8px',paddingBottom:'4px',borderBottom:'1px solid #ccc'}}>
			<div className="d-flex justify-content-between">
				<div>
					<small>
						<strong>{food.food_name}</strong> - <span className="text-info" style={{whiteSpace:'nowrap'}}>serving: {`${portion.size}${portion.unit}`}{Boolean(portion.description)?` (${portion.description})`:''}</span>
					</small>
					<br/>
					<small>
						{macros.map(macro=><span style={{whiteSpace:'nowrap'}} className="mr-1">{macro}: {prettyRound(parseFloat(portion[macro])*localQty,1)}</span>)}
					</small>
				</div>
				<div className="d-flex align-items-start ml-1">
					<div className="text-center">
						<input 
							onChange={handleEditQuantity}
							value={localQty}
							style={{
								width:'60px',
								height:'24px',
								border:'1px solid #ccc',
								borderRadius:'5px',
								textAlign:'center',
								fontSize:'16px'
							}}
						/>
						<small className="text-muted d-block">
							quantity
						</small>
					</div>
					<Button onClick={handleRemove} className="ml-3" variant="outline-danger" size="sm">
						<i className="fa fa-trash"/>
					</Button>
				</div>
			</div>
		</div>
	)
}

const Heading = ({heading})=>{
	return (
		<div style={{
			background:'#1f1f1f',
			color:'#eee',
			textAlign:'center',
			padding:'8px',
			margin:'8px 0'
		}}>
			{heading.heading}
		</div>
	)
}

const CustomMacroTotals = ({macros})=>{

	if (macros.length===0) return null
	//map from macro name to unit and qty
	const macroAggregateMap = {}
	const standardMacros = new Set(['calories','carbs','protein','fat'])
	macros.forEach(({macro,qty,unit})=>{
		if(standardMacros.has(macro.toLowerCase())) return 
		if(!macroAggregateMap[macro]){
			macroAggregateMap[macro] = {qty:0,unit}
		}
		macroAggregateMap[macro].qty+=qty
	})
	return (
		<div className="text-left">
			<small>
				{Object.entries(macroAggregateMap).map(([macro,{qty,unit}])=>(
					`${capitalize(macro)}: ${prettyRound(qty,1)} ${unit}`
				)).join(' | ')}
			</small>
		</div>
	)
}

const Meal = ({meal})=>{
	const macros = [
		'calories',
		'protein',
		'carbs',
		'fat',
		'sodium',
		'fiber'
	]

	const macrosMap = mealToMacroMap(meal)

	const customMacros = (
		Boolean(meal.recipe)
		? meal.recipe.macros
		: []
	)

	const [expandImage,setExpandImage] = useState(false)

	return (
		<>
			<div className="bg-success text-white text-center mb-1">
				{meal.name}{Boolean(meal.time)&&` (${meal.time})`}
				{Boolean(meal.image)&&
					<div className="text-center">
						<img
							onClick={()=>setExpandImage(prev=>!prev)}
							style={{
								margin:'auto',
								display:'block',
								width:expandImage?'600px':'80px',
								maxWidth:'100%',
								height:'auto',
								transition:'0.2s',
								objectFit:'cover',
								borderRadius:'5px',
								overflow:'hidden',
								cursor:'pointer'
							}} 
							src={meal.image}
						/>
						<small>
							Click to {expandImage?'Collapse':'Expand'}
						</small>
					</div>
				}
			</div>
			{(Boolean(meal.description)||Boolean(meal.ingredients))&&
				<div style={{whiteSpace:'pre-wrap'}}>
					{Boolean(meal.description)&&
						<>
							Description: 
							<br/>
							{meal.description}
							<hr/>
						</>
					}
					{Boolean(meal.ingredients)&&
						<>
							Ingredients
							<br/>
							{meal.ingredients}
						</>
					}
				</div>
			}
			{meal.foods.map( food => <Food food={food} /> )}
			{Boolean(meal.directions)&&
				<tr>
					<td colSpan="100%" style={{whiteSpace:'pre-wrap'}}>
						Directions: 
						<br/>
						{meal.directions}
					</td>
				</tr>
			}
			
			<div className="d-flex justify-content-between flex-wrap">
				<small><strong>{meal.name} Macro Totals</strong></small>
				<div className="d-flex">
					{macros.map( macro => (
						<small className="ml-2 text-center">
							<strong>{capitalize(macro)}</strong><br/>{macrosMap[macro].qty.toFixed(0)}
						</small>
					))}
				</div>
			</div>
			
			<CustomMacroTotals macros={customMacros}/>
			<div className="text-muted text-center" style={{borderBottom:'1px solid #ccc',marginBottom:'8px'}}>
				<small>End of {meal.name}</small>
			</div>
		</>
	)
}

const MealPhoto = ({photo})=>{
	const dispatch = useDispatch()

	const [expand,setExpand] = useState(false)

	const dispatchUpdate = (update)=>{
		dispatch(updateNutritionMealPhoto({
			id:photo.id,
			update
		}))
	}

	const debouncedDispatchUpdate = useDebounceCallback(dispatchUpdate,500)

	const handleDelete = ()=>{
		if (!window.confirm('Are you sure you want to delete this meal photo?')) return 
		dispatch(removeNutritionMealPhoto({
			id:photo.id,
			nutrition_id:photo.nutrition_id
		}))
	}
	return (
		<div className="d-flex mb-1 align-items-stretch">
			<div className="d-flex flex-column align-items-center mr-2">
				<img 
					src={photo.url}
					style={{
						height:expand?'400px':'200px',
						width:expand?'600px':'300px',
						objectFit:'contain'
					}}
					className="rounded"
					onClick={setExpand.bind(null,p=>!p)}
				/>
				<small>Click image to expand</small>
			</div>
			<div className="d-flex flex-column align-items-stretch" style={{flex:'1 1 auto'}}>
				<Form.Control 
					onChange={e=>{
						debouncedDispatchUpdate({notes:e.target.value})
					}}
					as="textarea" 
					defaultValue={photo.notes} 
					style={{flex:'1 1 auto'}}
				/>
				<div className="text-right mt-2">
					<Button onClick={handleDelete} variant="outline-danger" size="sm"> 
						Delete <i className="fa fa-trash"/>
					</Button>
				</div>
			</div>
		</div>
	)
}

const Placeholder = ({placeholder})=>{
	return (
		<tr>
			<td colSpan={9}>
				<span className="mr-2">{placeholder.text} </span>
				<Spinner animation="border" size="sm" />
			</td>
		</tr>
	)
}

const FoodLoggerModal = ({show,handleClose,nutrition_id,food})=>{
	const statusDispatch = useApiStatusDispatch()
	const [qty,setQty] = useState(1)
	const [portionId,setPortionId] = useState(food?.portions[0].id)
	const [isPending,setIsPending] = useState(false)
	const nutrition = useEvent('nutrition',nutrition_id)

	const handleLogFood = ()=>{
		setIsPending(true)
		const payload = {
			item_db_id:food.food_db_id,
			name:food.food_db_name,
			event_type:'nutrition',
			event_id:nutrition_id,
			food_db_portion_id:portionId,
			qty,
			routine_order:nutrition.food.length+1
		}

		statusDispatch(addItemToEvent(payload), "food", "add")
		.then(()=>{
			setIsPending(false)
			handleClose()
		})
	}
	if(!food)return null
	return (
		<Modal show={show} onHide={handleClose}>
			<Modal.Header closeButton>
				<strong>Log Food</strong>
			</Modal.Header>
			<Modal.Body className="d-flex align-items-center flex-column">
				<strong>{food.food_db_name}</strong>
				<Form.Control 
					value={qty}
					onChange={e=>{
						setQty(e.target.value)
					}}
					placeholder="quantity"
				/>
				<FoodPortionSelect 
					onChange={(portion)=>{
						console.log(portion)
						setPortionId(portion.id)
					}}
					enableRootClose={false}
					portions={food.portions}
					qty={parseFloat(qty) || 1}
				/>
				<div className="w-100 text-right mt-2">
					<Button 
						disabled={isPending}
						onClick={handleLogFood} 
						variant="outline-success"
					>
						Log Food {isPending&&<Spinner animation="border" size="sm"/>}
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

const MealPhotoModal = ({show,handleClose,nutrition_id})=>{
	const statusDispatch = useApiStatusDispatch()
	const [notes,setNotes] = useState('')
	const [image,setImage] = useState(null)
	const [isPending,setIsPending] = useState(false)

	const webcamRef = useRef(null);
	const capture = useCallback(() => {
		const imageSrc = webcamRef.current.getScreenshot()
		setImage(imageSrc)
	},[webcamRef])

	const {processUpload} = useS3DirectUpload()

	const handleLogFood = async ()=>{
		setIsPending(true)
		const s3Res = await processUpload(
			dataURLtoFile(image,'image.jpg')
		)
		statusDispatch(
			logNutritionMealPhoto({
				nutrition_id,
				url:s3Res.payload.url,
				notes
			}),
			'meal photo',
			'save'
		).then(()=>{
			setNotes('')
			setImage(null)
			setIsPending(false)
			handleClose()
		})
	}

	return (
		<Modal show={show} onHide={handleClose}>
			<Modal.Header closeButton>
				<strong>Log Photo of Meal</strong>
			</Modal.Header>
			<Modal.Body>
				{!Boolean(image)&&
					<>
						<FormControl 
							accept="image/*,.heic,.HEIC"
							onChange={e=>{
								const file = e.target.files[0]
								if (!file) return 
								setIsPending(true)
								const reader = new FileReader();
								reader.onloadend = () => {
									setImage(reader.result);
									setIsPending(false)
								};
								if(file.type.includes('heic')){
									heic2any({blob:file})
									.then(res=>{
										reader.readAsDataURL(res)
									})
								}
								else {
									
									reader.readAsDataURL(e.target.files[0])
								}
							}}
							type="file" 
							custom
						/>
						{isPending&&
							<small>Processing image</small>
						}
					</>
				}
				{!Boolean(image)&&
					<div className="d-flex align-items-center justify-content-center">
						<Webcam
							style={{maxWidth:'100%'}}
							audio={false}
							height={400}
							screenshotFormat="image/jpeg"
							width={600}
							ref={webcamRef}
							videoConstraints={{
								width: 900,
								height: 600,
								facingMode: "environment"
							}}
						/>
					</div>
				}

				{Boolean(image)&&
					<img className="d-block m-auto" style={{maxWidth:'100%'}} src={image}/>
				}

				{!Boolean(image)&&
					<Button 
						variant="outline-success" 
						onClick={capture} 
						className="mt-1"
						block 
					>
						Take Photo
					</Button>
				}

				{Boolean(image)&&
					<div>
						<strong>Notes (optional)</strong>
						<Form.Control 
							onChange={e=>{
								setNotes(e.target.value)
							}}
							as="textarea"
							value={notes}
						/>
						<div className="text-right mt-1">
							<Button 
								disabled={isPending}
								variant="outline-secondary" 
								onClick={setImage.bind(null,null)} 
								className="mr-1"
							>
								Retake Photo
							</Button>
							<Button 
								disabled={isPending}
								onClick={handleLogFood}
								variant="outline-success" 
							>
								Save Photo {isPending&&<Spinner animation="border" size="sm"/>}
							</Button>
						</div>
					</div>
				}
			</Modal.Body>
		</Modal>
	)
}

const Foods = ({foods,nutrition_id,goalMacros})=>{
	const dispatch = useDispatch()
	const user = useCurrentUser()

	const isClient = user.account_type === 'client'

	const permissions = useSelector(
		state => state.users.current_user.edit_permissions
	)

	const [showBarcodeScanner,setShowBarcodeScanner] = useState(false)
	const [isProcessingBarcode,setIsProcessingBarcode] = useState(false)
	const [showFoodLogger,setShowFoodLogger] = useState(false)
	const [showMealPhotoModal,setShowMealPhotoModal] = useState(false)
	const [scannedFood,setScannedFood] = useState(null)
	const handleBarcodeScan = (barcode)=>{
		console.log(barcode)
		if (isProcessingBarcode) return
		setIsProcessingBarcode(true)
		envAwarePost(
			'api/foods/',
			{
				action:'getFoodByBarcode',
				//need to add a leading 0 to the barcode 
				barcode:`0${barcode}`
			}
		).then(res=>{
			setIsProcessingBarcode(false)
			if (res.success==='0') {
				window.alert(res.message)
			} else {
				setShowFoodLogger(true)
				setShowBarcodeScanner(false)
				setScannedFood(res.data.food)
			}
		})
	}

	const foodKeys = [
		'quantity',
		'name',
		'portion_unit',
		'meal_time',
		'calories',
		'protein',
		'carbs',
		'fat',
		'notes'
	]

	const macros = [
		'calories',
		'protein',
		'carbs',
		'fat',
		'sodium',
		'fiber'
	]

	const macrosMap = nutritionItemstoMacroMap(foods)
	

	const customMacros = [].concat(
		...foods
			//get array of just the meals that are recipes
			.filter(item=>item.type === 'meal' && Boolean(item.recipe))
			.map(item=>item.recipe.macros)
	)

	const nutritionItem = item => {
		switch(item.type){
			case "food" : return <Food food={item}/>
			case "heading" : return <Heading heading={item}/>
			case "meal" : return <Meal meal={item}/>
			case "placeholder" : return <Placeholder placeholder={item}/>
			case "meal_photo": return <MealPhoto photo={item}/>
		}
	}

	return (
		<>
			{(!isClient||parseInt(permissions.nutrition)===1)&&
				<div className="my-1">
					<OverlayTrigger overlay={
						<Tooltip>
							Log what foods {isClient?"you've":'your client has'} eaten unto this daily nutrition plan
						</Tooltip>
					}>
						<Button 
							onClick={()=>{
								dispatch(
									updateResourceLibrary({
										show:true,
										resourceType:'food',
										tgtResourceId:nutrition_id,
										tgtResourceType:'nutrition'
									})
								)
							}}
							variant="outline-success" 
							className="mr-1"
						>
							<i className="fas fa-book"></i> Log From Library
						</Button>
					</OverlayTrigger>
					<OverlayTrigger overlay={
						<Tooltip>
							Scan food barcode to log what {isClient?"you've":'your client has'} eaten
						</Tooltip>
					}>
						<Button 
							onClick={setShowBarcodeScanner.bind(null,true)}
							variant="outline-success" 
							className="mr-1"
						>
							<i class="fas fa-barcode"></i> Log With Barcode
						</Button>
					</OverlayTrigger>
					<OverlayTrigger overlay={
						<Tooltip>
							Take a photo of the meal/food {isClient?"you":'your client'} ate
						</Tooltip>
					}>
						<Button 
							onClick={setShowMealPhotoModal.bind(null,true)}
							variant="outline-success" 
							className="mr-1"
						>
							<i class="fas fa-image"></i> Log Meal Photo
						</Button>
					</OverlayTrigger>
				</div>
			}
			{(foods && foods.length>0)&&
				<div>
					<div>
						{(foods||[]).map( nutritionItem )}
					</div>
					<div className="d-flex justify-content-between flex-wrap mt-1">
						<small>
							<strong>
								<u>Daily Macro Totals</u>
							</strong>
						</small>
						<div className="d-flex">
							{macros.map( macro => (
								<small className="d-block ml-2 text-center">
									<strong>
										{capitalize(macro)}
									</strong>
									<br/>
									{macrosMap[macro].qty.toFixed(0)}{Boolean(goalMacros[macro])&&` / ${goalMacros[macro]}`}
								</small>
							))}
						</div>
					</div>
					{(foods&&!user.isMAXUser)&&
							<a href="https://www.fatsecret.com">
								<img src="https://platform.fatsecret.com/api/static/images/powered_by_fatsecret.png" srcset="https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_2x.png 2x, https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_3x.png 3x" border="0"/>
							</a>
						}
				</div>
			}
			<BarcodeScanner 
				show={showBarcodeScanner}
				isProcessing={isProcessingBarcode}
				handleClose={setShowBarcodeScanner.bind(null,false)}
				onScan={handleBarcodeScan}
			/>
			<FoodLoggerModal
				show={showFoodLogger}
				handleClose={setShowFoodLogger.bind(null,false)}
				nutrition_id={nutrition_id}
				food={scannedFood}
			/>
			<MealPhotoModal
				show={showMealPhotoModal}
				handleClose={setShowMealPhotoModal.bind(null,false)}
				nutrition_id={nutrition_id}
			/>
		</>
	)
}

export default Foods